import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "27",
  height: "27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M26.5 13.5c0 7.18-5.82 13-13 13s-13-5.82-13-13 5.82-13 13-13 13 5.82 13 13Z",
  fill: "#282728",
  stroke: "#989799"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.5 7 6 12.6l.825 1.06 1.22-.913V19h10.91v-6.253l1.22.906L21 12.6 13.5 7Zm-2.727 8a.676.676 0 0 1-.682-.667c0-.366.307-.666.682-.666.375 0 .681.3.681.666a.676.676 0 0 1-.681.667Zm2.727 0a.676.676 0 0 1-.682-.667c0-.366.307-.666.682-.666.375 0 .682.3.682.666A.676.676 0 0 1 13.5 15Zm2.727 0a.676.676 0 0 1-.681-.667c0-.366.306-.666.681-.666.375 0 .682.3.682.666a.676.676 0 0 1-.682.667Z",
  fill: "#989799"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }